import React, {useEffect} from "react";
import {appdata} from "../../../logic_tmp/appdata/AppData";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {registerConcersion} from "../../../logic/funel/FacebookUtils";
import {init} from "../../../backend/connectors/JavaConnector";
import queryString from "query-string";
export function PaymentDone() {
    const {t} = useTranslation();
    const history = useHistory();

    function sendConfirmation(paymentMethod, instrument) {
        registerConcersion('Purchase');
        appdata.paymentMethod = paymentMethod;
        appdata.paymentInstrument = instrument;
        let queryParams = queryString.parse(window.location.search)
        appdata.reservationId = queryParams["reservationId"]
        init()
            .then(response => {
                if (response.status !== 200) {
                    return;
                }
            })
            .catch((error) => {
                return Promise.reject(error)
            })
    }
    useEffect(() => {
        sendConfirmation("BILL-OK","reservation")
        appdata.messageKey = "ThankYouForPaymentIWillSendTickets"
        history.push("/genericMessage");

    }, []);
    // @ts-ignore
    return (
        <div>
            ....
        </div>
    );
}
//http://localhost:3000/paymentdone?&utm_source=lg&utm_medium=COLD.TALLINN.RU.ANY.S1-All&utm_campaign=CELLO2023.C1.PURCHASE.Test&utm_content=CELLO2023-UNKNOWN.A1.Poster&utm_brand=goToPage&referenceId=&message=&skin=&productCode=EU2023-2023.05.25_KARLSRUHE-FIXED-PRICE-1
